import { getAppName } from "../../utils/accessControl";
import {encryptCredentials, fetchServerTimeAndNonce} from "../../utils/auth";
import axios from "axios";

// const authAPIEndpoint = `${process.env.REACT_APP_AUTH_API}/auth`;
const authAPIEndpoint = `/api/auth`;

export const login = (phone, password, searchParams) => async (dispatch) => {
  try {
    const redirect_uri = searchParams.get("redirect_uri");

    const appName = getAppName(redirect_uri);

    if (!appName) {
      return dispatch({
        type: "LOGIN_FAILURE",
        error: { message: "Invalid App" },
      });
    }

    const { serverTime, nonce } = await fetchServerTimeAndNonce(authAPIEndpoint);

    // encrypt credentials
    const credentials = await encryptCredentials({
      username: phone,
      password: password,
      redirect_uri,
      timestamp: serverTime,
      nonce,
    });

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Basic ${btoa(
        `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`,
      )}`,
    };

    const response = await axios.post(
      `${authAPIEndpoint}/login`,
      { credentials },
      { headers },
    );

    const data = response.data;

    if (data?.status === 200) {
      dispatch({
        type: "LOGIN_SUCCESS",
        payload: {
          user: data.idToken,
        },
      });

      const isLocalhostDev =
        searchParams.get("redirect_uri").includes("localhost") &&
        ["DEV", "STAGE"].includes(process.env.REACT_APP_ENVIRONMENT);

      // Field-app MFA: require an OTP after the password before redirecting.
      // <Login/> shows the OTP step and finishes the redirect on success.
      if (appName === "web:field") {
        dispatch({
          type: "MFA_REQUIRED",
          payload: {
            phone,
            redirectUri: redirect_uri,
            isLocalhostDev,
            tokens: isLocalhostDev
              ? {
                  token: data.accessToken,
                  idToken: data.idToken,
                  refreshToken: data.refreshToken,
                }
              : null,
          },
        });
        return;
      }

      if (isLocalhostDev) {
        const token = data.accessToken;
        const idToken = data.idToken;
        const refreshToken = data.refreshToken;

        window.location.href =
          searchParams.get("redirect_uri") +
          `?token=${token}&idToken=${idToken}&refreshToken=${refreshToken}`;
      } else {
        window.location.href = searchParams.get("redirect_uri");
      }
    } else {
      localStorage.clear();
      dispatch({
        type: "LOGIN_FAILURE",
        error: {
          message: "This Role is Unauthorized to Access the Client App",
        },
      });
    }
  } catch (error) {
    dispatch({
      type: "LOGIN_FAILURE",
      error: error?.response?.data || { message: "Login failed" },
    });
  }
};

export const logout = (_client_id) => async (dispatch) => {
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Basic ${btoa(
        `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`,
      )}`,
    };

    const response = await axios.post(
      `${authAPIEndpoint}/logout`,
      {},
      { headers, withCredentials: true },
    );

    const data = response.data;

    console.log("RESPONSE:", data);

    if (data?.status === 200) {
      dispatch({ type: "LOGOUT" });
    }
  } catch (error) {
    dispatch({ type: "LOGOUT_FAILURE", error });
  }
};
